/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/keys",
    "mw-form/TextArea",
    "../mixins/property/MnemonicMixin",
    "../mixins/property/MnemonicKeyNavDirectionMixin",
    "../mixins/AcceptFocusMixin",
    "../mixins/ColumnWidthMixin",
    "../mixins/property/TypeMixin",
    "../mixins/property/DescriptionOverrideMixin",
    "../mixins/property/CompactMixin",
    "mw-form/mixins/property/ShortcutMixin",
    "../mixins/ScrollbarMixin",
    "mw-form/mixins/property/ValidationMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, keys, TextArea, MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin, ColumnWidthMixin, TypeMixin, DescriptionOverrideMixin,
                CompactMixin, ShortcutMixin, ScrollbarMixin, ValidationMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([TextArea, MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin, ColumnWidthMixin, TypeMixin,
        DescriptionOverrideMixin, CompactMixin, ShortcutMixin, ScrollbarMixin, ValidationMixin]), {
        visualFamily: "default",
        width: 150,
        height: 66,
        mnemonicKeyNavDirection: "none",
        _scaleToParentWidth: true,

        //Override typing event mixin of consolidated widget to emit "text" instead of "currentContent"
        _triggerTypingEvent: function (value) {
            this.emit("typing", {
                mwEventData: {
                    text: value
                }
            });
        },

        _onFocus: function() {
            this.inherited(arguments);
            this.emit("focusgained", {mwEventData:{text: this.inputNode.value}});
        },

        _onBlur: function() {
            this.inherited(arguments);
            this.emit("focuslost", {mwEventData:{text: this.inputNode.value}});
        },
        //Overriding Consolidated TextArea: Adding ESC behavior
        _onKeyUp: function (e) {
            if (e.keyCode === keys.ESCAPE) {
                this.emit("restorefocustolastnonrefuseelement");
            }
            this.inherited(arguments);
        }
    });

});
